import { useTranslations } from 'next-intl';
import { ModalPortal } from '@/components/layout/modals/ModalPortal';
import { Button } from '@/components/ui/button/Button';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onClick: () => void;
};

export const MigrationNotificationModal = ({ isOpen, onClose, onClick }: Props) => {
  const t = useTranslations();

  return (
    <ModalPortal
      isOpen={isOpen}
      title={t('livenode-id-migration-notification_title')}
      body={t('livenode-id-migration-required_description')}
      onClose={onClose}
      PrimaryButtonComponent={() => {
        return <Button label={t('common-continue')} fullWidth onClick={onClick} />;
      }}
    />
  );
};
